import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchSinglePost = createAsyncThunk(
  "blogs/fetchSinglePost",
  async (postId) => {
    const response = await fetch(`http://localhost:9000/blogs/${postId}`);
    const data = await response.json();
    return data;
  }
);

export const fetchRelatedPosts = createAsyncThunk(
  "blogs/fetchRelatedBlogs",
  async (tags) => {
    const response = await fetch(
      `http://localhost:9000/blogs?tags_like=${tags.join("&tags_like=")}`
    );
    const data = await response.json();
    return data;
  }
);

const initialState = {
  post: null,
  loading: false,
  error: null,
  relatedPosts: [],
  relatedPostsError: null,
};

const blogDetailsSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSinglePost.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSinglePost.fulfilled, (state, action) => {
        state.loading = false;
        state.post = action.payload;
        state.error = null;
      })
      .addCase(fetchSinglePost.rejected, (state, action) => {
        state.loading = false;
        state.post = null;
        state.error = action.error.message;
      })
      .addCase(fetchRelatedPosts.fulfilled, (state, action) => {
        state.relatedPosts = action.payload;
        state.relatedPostsError = null;
      })
      .addCase(fetchRelatedPosts.rejected, (state, action) => {
        state.relatedPostsError = action.error.message;
        state.relatedPosts = [];
      });
  },
});

export default blogDetailsSlice.reducer;
